<section id="contact" style="padding:40px;padding-right:5px;padding-left:4px;">
  <div class="container">
      <form id="contactForm" style="padding:15px;" action="javascript:void();" method="post">
          <div class="form-row" style="margin-left:0px;margin-right:0px;padding:10px;">
              <div class="col-md-6" style="padding-left:20px;padding-right:20px;">
                  <fieldset></fieldset>
                  <legend><i class="fa fa-info"></i>Thông tin liên hệ</legend>
                  <p></p>
                  <div class="table-responsive">
                      <table class="table">
                          <tbody>
                              <tr>
                                  <td><i class="fa fa-building"></i></td>
                                  <td>P2007-CT1 - KĐT Xa La, Hà Đông</td>
                              </tr>
                              <tr>
                                  <td><i class="fa fa-map-marker"></i></td>
                                  <td>250A, Quang Trung, Thanh Xuân, HN</td>
                              </tr>
                              <tr>
                                  <td><i class="fa fa-phone"></i></td>
                                  <td>0822-030-668 | 094-660-8880</td>
                              </tr>
                              <tr>
                                  <td><i class="fa fa-envelope"></i></td>
                                  <td>azkho@gmail.com</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
              <div class="col-12 col-md-6" id="message" style="padding-right:20px;padding-left:20px;">
                  <fieldset>
                      <legend><i class="fa fa-envelope"></i> Contact</legend>
                  </fieldset>
                  <div class="form-group has-feedback"><label for="from_name">Name</label><input class="form-control" type="text" id="from_name" tabindex="-1" name="from_name" required placeholder="Your name" /></div>
                  <div class="form-group has-feedback"><label for="from_email">Email</label><input class="form-control" type="email" id="from_email" name="from_email" required placeholder="Your email address" /></div>
                  <div class="form-row">
                      <div class="col-sm-6">
                          <div class="form-group has-feedback"><label for="from_phone">Title</label><input class="form-control" type="text" id="from_phone" name="subject" placeholder="Enter title" /></div>
                      </div>
                      <div class="col-sm-6">
                          <div class="form-group"><label for="calltime">To department</label><select class="form-control" id="calltime" name="afdeling" value="Afdeling" required>
                            <option value="Sales">Sales</option>
                            <option value="Technische Dienst">Technical support</option>
                            <option value="Webdevelopers">Webdevelopers</option></select></div>
                      </div>
                  </div>
                  <div class="form-group"><label for="comments">Content</label><textarea class="form-control" id="comments" name="Comments" placeholder="Type content.." rows="5"></textarea></div>
                  <div class="form-group"><button class="btn btn-primary active btn-block" style="background-color:#303641;" type="submit">Send <i class="fa fa-chevron-circle-right"></i></button></div>
                  <hr />
              </div>
          </div>
      </form>
  </div>
</section>
